/*
|--------------------------------------------------------------------------
| Social: Twitter
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.social.twitter = {

	/**
	 * Initialize Twitter for widgets etc.
	 * @namespace
	 */
	"init": function() {
		if (!this.isLoaded())
		{
			window.twttr = (function (d, s, id) {
			var t, js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			js = d.createElement(s);
			js.id = id;
			js.src	= "https://platform.twitter.com/widgets.js";
			fjs.parentNode.insertBefore(js, fjs);

			return window.twttr || (t = { _e: [], ready: function (f) { t._e.push(f) } });
			}(document, "script", "twitter-wjs"));
		}
	},


	/**
	 * Load all on the page
	 * @namespace
	 */
	"loadAllWidgets": function() {
		var twitterObj = this;
		twitterObj.init();
		$("[data-gh-twitter-widget-loaded=false]").each(function(){
			var $twitter  	= $(this),
				options		= {
					"domId"		: $twitter.attr('id'),
					"widgetId"	: $twitter.data('gh-twitter-widget-id'),
					"height"	: $twitter.data('gh-twitter-widget-height')
				};
			//Set loaded to true so it's not called again.
			$twitter.attr("data-gh-twitter-widget-loaded",true);
			twitterObj.createWidget(options);
	  	});
	},


	/**
	 * Create a twitter timeline widget
	 * @namespace
	 * @param {object} options
	 * @param {integer} options.widgetId - twitter widget id
	 * @param {string} options.domId - Id for the element the widget will be put into
	 * @param {string} options.url - saw it in the feed, might not be necessary, not sure how it's used yet.
	 */
	"createWidget": function(options) {
		var widgetId 	= (options.widgetId) 	? options.widgetId 	: false,
			url			= (options.url)			? options.url		: false,
			domId		= (options.domId)		? options.domId		: false,
			height		= (options.height)		? options.height	: 600;

		if(!options.domId){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.social.twitter.createWidget",message:"Missing domId."});
			return;
		}

		if(!options.widgetId){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.social.twitter.createWidget",message:"Missing widgetId."});
			return;
		}

		twttr.ready(function (twttr) {
		  	// Build Twitter Widget
			twttr.widgets.createTimeline(
			  widgetId,
			  document.getElementById(domId),
			  {
			    chrome: 'noheader',
			    related: 'twitterdev,twitterapi',
			  });
		});
	},


	/**
	 * Checks if it's initialized
	 * @namespace
	 */
	"isLoaded": function(options) {
		if (window.twttr){ return true; }
		return false;
	}

};